import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.CompanyInfoPage.OrganisationInfo', {
    organisationNameLabel: 'Organisation name',
    organisationNamePlaceholder: 'Enter a name for the Organisation',
    enforcementTwoFaLabel: 'Two-factor authentication Enforcement',
    timeZonePlaceholder: 'Time zone',
    timeZoneLabel: 'Time zone',

    deleteCompanyMenuItemTitle: 'Delete the Organisation',
    transferCompanyMenuItemTitle: 'Transfer company',
    transferCompanyMenuItemText: 'Request Organisation transfer',
    deleteCompanyMenuItemText: 'Delete',
    enforcementTwoFaOptionNone: 'None',
    enforcementTwoFaOptionSoft: 'Soft Enforcement',
    enforcementTwoFaOptionHard: 'Hard Enforcement',

    currencyPlaceholder: 'Currency',
    currencyFieldText: 'Currency',
    financialYearEndFieldText: 'Financial Year End',
    lockDateFieldText: 'Lock Date',
    isAccountExpandedFieldText: 'Expand account lists',
    isAccountExpandedCheckboxText: 'Yes',
    taxCodeLists: 'Tax code lists',
    taxCodeListsPlaceholder: 'Select value',
    taxCodesOnlyValue: 'Tax codes only',
    taxGroupsOnlyValue: 'Tax groups only',
    taxGroupsAndTaxCodesValue: 'Tax groups and tax codes',

    buttonSaveChanges: 'Save changes',
});
